import { z } from "zod";

export const createPayRuleProfileSchema = z.object({
  name: z.string().min(1).max(120),
  stackingMode: z.enum(["HIGHEST_MULTIPLIER_WINS", "STACK_MULTIPLIERS", "CUSTOM_PRIORITY"]).default("HIGHEST_MULTIPLIER_WINS"),
  rules: z
    .array(
      z.object({
        type: z.enum([
          "DAILY_OT",
          "DAILY_DT",
          "WEEKLY_OT",
          "WEEKEND",
          "HOLIDAY",
          "NIGHT_SHIFT",
          "HAZARD",
          "TRAINING",
        ]),
        thresholdHours: z.number().nonnegative().optional(),
        multiplier: z.number().positive().optional(),
        flatAmount: z.number().nonnegative().optional(),
        percentagePremium: z.number().nonnegative().optional(),
        priority: z.number().int().optional(),
        active: z.boolean().default(true),
      }),
    )
    .default([]),
});

export type CreatePayRuleProfileInput = z.infer<typeof createPayRuleProfileSchema>;

export const payRuleProfileSummarySchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  stackingMode: z.enum(["HIGHEST_MULTIPLIER_WINS", "STACK_MULTIPLIERS", "CUSTOM_PRIORITY"]),
  active: z.boolean(),
  ruleCount: z.number().int(),
});

export type PayRuleProfileSummary = z.infer<typeof payRuleProfileSummarySchema>;

export const resolveExceptionSchema = z.object({
  reason: z.string().max(500).optional(),
});
